import { render, staticRenderFns } from "./DateWidget.vue?vue&type=template&id=610c7693&scoped=true"
import script from "./DateWidget.vue?vue&type=script&lang=js"
export * from "./DateWidget.vue?vue&type=script&lang=js"
import style0 from "./DateWidget.vue?vue&type=style&index=0&id=610c7693&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c7693",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610c7693')) {
      api.createRecord('610c7693', component.options)
    } else {
      api.reload('610c7693', component.options)
    }
    module.hot.accept("./DateWidget.vue?vue&type=template&id=610c7693&scoped=true", function () {
      api.rerender('610c7693', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/DateWidget.vue"
export default component.exports